import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { removeTag } from '../../../utils/api/site';
import { useDialogs, useToasts } from '../../../hooks';
import TagModal from '../../Tags/TagsTabbedModal';
import SiteTags from './SiteTags';
import { useUrlModals } from '../../../utils/useUrlModals';

const SiteTagsWrapper = ({ site, organizationTags, setSiteData }) => {
  const { showToast } = useToasts();
  const { openDialog, closeDialog } = useDialogs();

  const [assignedTags, setAssignedTags] = useState(site.tags || []);
  const [unassignedTags, setUnassignedTags] = useState(organizationTags || []);

  const { modals, openModal, closeModal } = useUrlModals({
    tagModal: { isIdParam: false },
  });

  useEffect(() => {
    if (site.tags && site.tags.length > 0) {
      const newUnassignedTags = organizationTags.filter(
        (elem) => !site.tags.find(({ id }) => elem.id === id),
      );
      setUnassignedTags(newUnassignedTags);
    }
    setAssignedTags(site.tags);
  }, [site, organizationTags]);

  const onDelete = (tag, tagName) => {
    removeTag(tag.id, site.id, site.organization_id)
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setAssignedTags((prevAssignedTags) => prevAssignedTags.filter(({ id }) => id !== tag.id));
          setUnassignedTags([...unassignedTags, { id: tag.id, name: tagName }]);
          setSiteData((prevSiteData) => ({
            ...prevSiteData,
            tags: prevSiteData.tags.filter(({ id }) => id !== tag.id),
          }));
        }
      })
      .catch((error) => {
        showToast({ message: error.message, type: 'error' });
      });
  };

  const handleOpenDeleteModal = (tagId, tagName) => {
    openDialog({
      message: 'Are you sure you want to delete this tag from the site?',
      show: true,
      actions: [
        {
          label: 'Yes',
          onClick: () => {
            onDelete(tagId, tagName);
            closeDialog();
          },
        },
        {
          label: 'No',
          variant: 'danger',
          onClick: closeDialog,
        },
      ],
    });
  };

  const onCreate = (tagData) => {
    const tagsArray = Array.isArray(tagData) ? tagData : [tagData];

    setAssignedTags((prev) => [...prev, ...tagsArray]);
    setUnassignedTags((prev) => prev.filter((tag) => !tagsArray.some((newTag) => newTag.id === tag.id)));

    setSiteData((prevSiteData) => ({
      ...prevSiteData,
      tags: [...prevSiteData.tags, ...tagsArray],
    }));

    closeModal('tagModal');
  };

  return (
    <div className="flex flex-col pb-6 pt-9.75">
      <SiteTags
        handleOpenDeleteModal={handleOpenDeleteModal}
        assignedTags={assignedTags}
        setShowTagModal={() => openModal('tagModal')}
      />
      {modals.tagModal?.isOpen && (
        <TagModal
          handleClose={() => closeModal('tagModal')}
          siteIds={[site.id]}
          orgId={site.organization_id}
          onCreate={onCreate}
          onDelete={onDelete}
          title="Tags"
          isTagAsTabShowing
          isCreateNewTabShowing
          existingTags={assignedTags}
        />
      )}
    </div>
  );
};

SiteTagsWrapper.propTypes = {
  site: PropTypes.object.isRequired,
  organizationTags: PropTypes.array.isRequired,
  setSiteData: PropTypes.func.isRequired,
};

export default SiteTagsWrapper;
